import React, { Component } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import Loadable from "react-loadable";

// custom
import LoadableLoading from 'components/common/loading/LoadableLoading';
import NotFound from 'components/error/NotFound';
import { 
    LIST_INFO, 
    DOCUMENT_COMMON_ROUTES,
    DOCUMENT_GRAPH_VISUALIZATION_ROUTES
} from 'util/constants';

// Route-based code splitting 적용 
const DocumentLayout = Loadable({
    loader: () => import('views/layout/DocumentLayout' /* webpackChunkName: "documentLayout" */ ),
    loading: LoadableLoading,
    delay: 200, // 0.2 seconds
});

const DocumentFileRegistrationLayout = Loadable({
    loader: () => import('views/layout/DocumentFileRegistrationLayout' /* webpackChunkName: "documentAddLayout" */ ),
    loading: LoadableLoading,
    delay: 200 // 0.2 seconds
});

const DocumentGraphVisualizationLayout = Loadable({
    loader: () => import('views/layout/DocumentGraphVisualizationLayout' /* webpackChunkName: "documentGraphVisualizationLayout" */ ),
    loading: LoadableLoading,
    delay: 200, // 0.2 seconds
});

class Main extends Component {
    render() {
        
        return (
            <Switch>
                <Route path={LIST_INFO["document.file"].PATH} component={DocumentLayout} />
                {DOCUMENT_COMMON_ROUTES.map(route => (
                    <Route
                        key={route.id}
                        path={route.path}
                        component={DocumentFileRegistrationLayout}
                    />
                ))}
                {DOCUMENT_GRAPH_VISUALIZATION_ROUTES.map(route => (
                    <Route
                        key={route.id}
                        path={route.path}
                        component={DocumentGraphVisualizationLayout}
                    />
                ))}
                <Route component={NotFound} />
            </Switch>
        );
    }
}

export default withRouter(Main);
